import CheckboxGroup from "@/components/CheckboxGroup";
import useThemeData from "@/hooks/useThemeData";
import { renderBanksLogo } from "@/utils/commonRender";

import { useFilterContext } from "../FilterContext";

const FilterItemBanks = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount } = useFilterContext();
  const { isDarkMode } = useThemeData();
  return (
    <CheckboxGroup
      options={filterOptions.banksOptions.map((item) => {
        const bank = item.value;
        return {
          ...item,
          label: `${item.label == "Z" ? "None" : item.label} (${filterOptionsCount["banks"][
            bank
          ]?.progress.toLocaleString()}/${filterOptionsCount["banks"][
            bank
          ]?.total.toLocaleString()})`,
        };
      })}
      value={
        filterData.banks.length > 0
          ? filterData.banks
          : filterOptions.banksOptions.map(({ value }) => value)
      }
      onChange={(value) => {
        setFilterData({
          banks: value.length === filterOptions.banksOptions.length ? [] : value,
        });
      }}
      renderPrefix={(item) => renderBanksLogo(item.value, isDarkMode)}
    />
  );
};

export default FilterItemBanks;
